import styled from 'styled-components'
import _TrackItemWrapper from '../TrackItemWrapper'
import { COLORS } from 'consts/colors'
import { TIMELINE_RULER_HEIGHT } from '../../consts'
import _Text from 'common-components/Text'
import { disableSomeContentStyles } from 'styles/mixins'
import { SpinningLoader } from 'common-components'

export const TrackItem = styled.div<{
  $isActive: boolean
  $backgroundColor: string
  $isDisabled: boolean
}>`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 0 1px;
  box-sizing: border-box;
  border-radius: 4px;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  ${({ $isDisabled }) => $isDisabled && disableSomeContentStyles(0.5)}
  scroll-margin-top: ${TIMELINE_RULER_HEIGHT}px;
`

export const AudioTracks = styled.div`
  & .audio-track {
    background-color: ${COLORS.primaryLight};
    border-radius: 4px;
  }
`

export const TrackItemWrapper = styled(_TrackItemWrapper)`
  .resize-button,
  &:before,
  &:after {
    background-color: ${COLORS.secondarySemiDark};
  }
`

export const AudioNameWrapper = styled.div`
  position: absolute;
  width: 100%;
  z-index: 3;
  padding: 0 10px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
`

export const Text = styled(_Text)`
  display: inline-block;
`

export const BlobLoader = styled(SpinningLoader)`
  margin-left: 12px;
  z-index: 2;
`
